/* @ngInject */
const dispositionOptions = (
  utils,
  types,
  excelStyles,
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'dispositionSorting'
    options.enableColor = true
    options.enableOwnerSheet = false
    options.firstRow = 4
    options.getBodyCells = self.getBodyCells
    options.style = excelStyles.bodyCell()
    return options
  }

  self.getBodyCells = ({ currentRow, }, wagon) => {
    return [{
      name: 'A' + currentRow,
      ref: 'id',
      value: wagon.id,
      type: types.wagonId,
    }, {
      name: 'B' + currentRow,
      ref: 'idNew',
      value: wagon.idNew,
      type: types.wagonId,
    }, {
      name: 'C' + currentRow,
      ref: 'owner',
      value: wagon.owner,
    }, {
      name: 'D' + currentRow,
      ref: 'type',
      value: wagon.type,
    }, {
      name: 'E' + currentRow,
      ref: 'railway',
      value: wagon.railway,
    }, {
      name: 'F' + currentRow,
      ref: 'integer',
      value: wagon.ratioPosition,
      type: types.integer,
    }, {
      name: 'G' + currentRow,
      ref: 'completeRevisionExcel',
      value: wagon.completeRevisionExcel,
    }, {
      name: 'H' + currentRow,
      ref: 'dossier',
      value: wagon.dossier,
    }, {
      name: 'I' + currentRow,
      ref: 'status',
      value: wagon.status,
    }, {
      name: 'J' + currentRow,
      ref: 'state',
      value: wagon.state,
    }, {
      name: 'K' + currentRow,
      ref: 'damaged',
      value: wagon.damaged,
      type: types.boolean,
    }, {
      name: 'L' + currentRow,
      ref: 'isolated',
      value: wagon.isolated,
      type: types.boolean,
    }, {
      name: 'M' + currentRow,
      ref: 'dispositionDate',
      value: wagon.dispositionDate,
      type: types.date,
    }, {
      name: 'N' + currentRow,
      ref: 'workshop',
      value: wagon.workshop,
    },]
  }

  return self
}
export default dispositionOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/wagon/dispositionOptions.resource.js